export default __webpack_public_path__ + "static/media/003-drum.25086457.svg";